import { useContext } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import ForwardRefContext from 'src/contexts/ForwardRefContext';
import {
  getEditorMarkdown,
  getSelectedContent,
  getTextBlock,
} from '../../utils';
import { PromptForm } from '../PromptForm';
import { useRunEditorStream } from 'src/hooks';
import { getHumanMessage } from 'src/utils';
import { EditorGraphInput } from 'src/types';
import { useDocumentAutoSave } from 'src/hooks/editorHooks/useDocumentAutoSave';

export const FloatingPrompt = () => {
  const [editor] = useLexicalComposerContext();
  const { floatingElementPluginRef } = useContext(ForwardRefContext);
  const { onRunEditorStream } = useRunEditorStream();
  const { onDocumentAutoSave } = useDocumentAutoSave();

  const handleSubmit = async (userPrompt: string) => {
    const selectedText = getSelectedContent(editor);
    const markdownBlock = await getTextBlock(editor);
    const fullMarkdown = getEditorMarkdown(editor);
    await onDocumentAutoSave(fullMarkdown);

    floatingElementPluginRef?.current?.onElementClose();

    editor.read(() => {
      const rootElement = editor.getRootElement();
      if (rootElement) {
        rootElement.focus();
      }
    });

    const userMessage = getHumanMessage(userPrompt);
    const input: EditorGraphInput = {
      userMessage,
      highlightedText: {
        fullMarkdown,
        markdownBlock,
        selectedText,
      },
    };

    await onRunEditorStream(input);
  };

  return (
    <PromptForm
      onSubmit={handleSubmit}
      placeholder="Add more detail about this"
    />
  );
};
